module.exports = __webpack_public_path__ + "img/orange_025.268d5cf6.png";